import { useEffect, useState } from 'react';
import { getUserState } from '../../components/utils';
import { UserSession } from '../types/UserData';

export const useGetUserData = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<unknown | undefined>();
    const [userSession, setUserSession] = useState<UserSession | undefined>(undefined);

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            setError(undefined);

            try {
                const userSession = await getUserState();
                setUserSession(userSession);
            } catch (error: unknown) {
                console.error("failed getting the user's data from server!", error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserData();
    }, []);

    return {
        loading,
        error,
        userSession
    };
};
